import Row from '../Row';

export default [
    {
        component: Row,
        props: {
            id: 'cr_hranice',
            type: 'overlay',
            category: 'layer',
            className: 'js-layer',
            value: 'cr_hranice',
            name: 'Hranice ČR',
            initial: false,
            icon: false,
        }
    },
    {
        component: Row,
        props: {
            id: 'cr_kraje',
            type: 'overlay',
            category: 'layer',
            className: 'js-layer',
            value: 'cr_kraje',
            name: 'Kraje',
            initial: false,
            icon: false,
        }
    },
    {
        component: Row,
        props: {
            id: 'cr_okresy',
            type: 'overlay',
            category: 'layer',
            className: 'js-layer',
            value: 'cr_okresy',
            name: 'Okresy',
            initial: false,
            icon: false,
        }
    }
];
